import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    SetUnifiedGroupMembershipStateJsonResponse,
    UnifiedGroupMembershipActionType,
    UnifiedGroupIdentity,
    UnifiedGroupIdentityType,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature } from '../../../../shared';
import { getGroupOwsOptions } from '../utils/groupsOwsUtils';

function setMembershipStateRequest(
    groupId: string,
    groupSmtp: string,
    memberSmtp: string,
    action: 'join' | 'leave'
): Promise<SetUnifiedGroupMembershipStateJsonResponse> {
    const groupIdentity: UnifiedGroupIdentity = {
        Type: UnifiedGroupIdentityType.ExternalDirectoryObjectId,
        Value: groupId,
    };

    const members = [];
    members.push(memberSmtp);
    return getServiceAsync().then(service =>
        service.Operation.setUnifiedGroupMembershipStateOperation(
            {
                Header: getJsonRequestHeader(),
                Body: service.Factory.setUnifiedGroupMembershipStateRequest({
                    GroupIdentity: groupIdentity,
                    Action:
                        action === 'join'
                            ? UnifiedGroupMembershipActionType.Add
                            : UnifiedGroupMembershipActionType.Remove,
                    Members: members,
                }),
            },
            getGroupOwsOptions(groupSmtp)
        )
    );
}

export default function setUnifiedGroupMembershipState(
    groupId: string,
    groupSmtp: string,
    memberSmtp: string,
    action: 'join' | 'leave'
): Promise<SetUnifiedGroupMembershipStateJsonResponse> {
    return runOwsRequestWithMonitor({
        scenarioName: 'SetUnifiedGroupMembershipState',
        feature: Feature.UnifiedGroups,
        operation: () => setMembershipStateRequest(groupId, groupSmtp, memberSmtp, action),
        transformResponse: (owsResponse: SetUnifiedGroupMembershipStateJsonResponse) => owsResponse,
    });
}
